import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { BranchesPageView } from './BranchesPageView';
import { useBranchesPage } from './useBranchesPage';

/**
 * `/branches` — the tab shell every `/branches*` URL renders.
 *
 * Two tabs at two depths of the same subject: the branches that exist, and the
 * shifts that were run at them. Each owns its data and its own `ErrorBoundary`,
 * so this shell holds neither — and each states its own readiness, rather than
 * flattening a role gate that applies to only one of them into a label here.
 *
 * No width cap of its own. The branch list keeps the `max-w-7xl` the catalog
 * screens share; the shift register wants the whole viewport for its columns.
 */
export const BranchesPage: React.FC = () => {
    const page = useBranchesPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('branches-page')}
        >
            <BranchesPageView
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
            />
        </div>
    );
};
